import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { t } from 'ttag';
import SatfarmLogo from '../../../media/logo.svg';

const PanelLeftWrap = styled.div`
  width: 40vw;
  min-width: 400px;
  max-width: 600px;
  height: 100%;
  min-height: 100vh;
  max-height: 100vh;
  overflow-y: auto;
  position: relative;
  padding: ${({ theme }) => theme.spacing03} ${({ theme }) => theme.spacing04};
  .panel-left-icon-language-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: ${({ theme }) => theme.spacing02};
    margin-bottom: ${({ theme }) => theme.spacing02};
    border-bottom: 1px solid ${({ theme }) => theme.colorUI30};
    .panel-left-logo {
      width: 120px;
    }
  }
  .app-toggle {
    position: absolute;
    top: 1.3rem;
    right: 2rem;
    a {
      text-decoration: none;
      color: ${({ theme }) => theme.colorPrimary50};

      &:hover {
        color: ${({ theme }) => theme.colorPrimary70};
      }
    }
  }
`;

export function PanelLeft({ children }) {
  const isPolicyMakersView = window.location.href.includes('/policy-makers');

  return (
    <PanelLeftWrap>
      <div className="panel-left-icon-language-wrap">
        <img className="panel-left-logo" src={SatfarmLogo} alt="" />
      </div>
      <div className="app-toggle">
        {isPolicyMakersView ? (
          <Link className="link-primary-small" to={`/`}>
            {t`Farmers view`}
          </Link>
        ) : (
          <Link className="link-primary-small" to={`/policy-makers`}>
            {t`Policy makers view`}
          </Link>
        )}
      </div>
      {children}
    </PanelLeftWrap>
  );
}
